<template>
    <div>
        <index-page></index-page>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
             
        };
    },
    created(){
        
    },
    methods: {
        
    },
};
</script>

<style scoped>
</style>